// extracted by css-extract-rspack-plugin
export default {"root":"root-vUv_Qx","page":"page-FeMgth"};